/**
 * A custom implementation of quicksort that can have a custom swap function
 * @module
 */

export type CompareFunc = (a: number, b: number) => boolean;
export type SwapFunc = (a: number, b: number) => void;

export function quicksort(left: number, right: number, compare: CompareFunc, swap: SwapFunc) {
  if (right - left === 1) {
    if (compare(left, right)) {
      swap(left, right);
    }

    return;
  }

  if (left < right) {
    const index = partition(left, right, compare, swap);

    quicksort(left, index - 1, compare, swap);
    quicksort(index + 1, right, compare, swap);
  }
}

function partition(left: number, right: number, compare: CompareFunc, swap: SwapFunc) {
  let i = left - 1;

  for (let j = left; j <= right - 1; j++) {
    if (!compare(j, right)) {
      i++;
      swap(i, j);
    }
  }

  swap(i + 1, right);
  return i + 1;
}
